var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.146,
    height: 18.147,
    viewBox: "0 0 18.146 18.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82c5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3dbb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-10603.34,17.489l-5.66-5.661-5.66,5.661a2,2,0,0,1-2.82,0,1.987,1.987,0,0,1,0-2.83l5.656-5.658-5.656-5.661a1.987,1.987,0,0,1,0-2.83,2,2,0,0,1,2.82,0l5.664,5.665,5.656-5.657a1.989,1.989,0,0,1,2.828,0,1.991,1.991,0,0,1,0,2.821l-5.66,5.662,5.652,5.657a1.987,1.987,0,0,1,0,2.83,1.988,1.988,0,0,1-1.41.584A1.988,1.988,0,0,1-10603.34,17.489Z",
    transform: "translate(10618.072 0.073)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.297a06aa07e1240a44a7656949c1e79e.svg";
export { ForwardRef as ReactComponent };